import { render, staticRenderFns } from "./SiteIconEdit.vue?vue&type=template&id=486e441b&scoped=true"
import script from "./SiteIconEdit.vue?vue&type=script&lang=js"
export * from "./SiteIconEdit.vue?vue&type=script&lang=js"
import style0 from "./SiteIconEdit.vue?vue&type=style&index=0&id=486e441b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e441b",
  null
  
)

export default component.exports